import {
  ADD_UPDATE_NAUTILUS_ITEMDETAILS_FAILURE,
  ADD_UPDATE_NAUTILUS_ITEMDETAILS_REQUEST,
  ADD_UPDATE_NAUTILUS_ITEMDETAILS_SUCCESS,
  FETCH_NAUTILUS_ITEMDETAILS_LIST_FAILURE,
  FETCH_NAUTILUS_ITEMDETAILS_LIST_REQUEST,
  FETCH_NAUTILUS_ITEMDETAILS_LIST_SUCCESS,
} from "./actionTypes";
import { NautilusItemDetails } from "./types";

export const fetchNautilusItemDetailsListRequest = (
  url: string,
  payload: {
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortOrder: string;
    searchValue: string;
  },
) => ({
  type: FETCH_NAUTILUS_ITEMDETAILS_LIST_REQUEST,
  url,
  payload,
});

export const fetchNautilusItemDetailsListSuccess = (
  nautilusItemDetailsList: NautilusItemDetails[],
  totalCount: number,
) => ({
  type: FETCH_NAUTILUS_ITEMDETAILS_LIST_SUCCESS,
  payload: { nautilusItemDetailsList, totalCount },
});

export const fetchNautilusItemDetailsListFailure = (error: string) => ({
  type: FETCH_NAUTILUS_ITEMDETAILS_LIST_FAILURE,
  payload: error,
});

export const addUpdateNautilusItemDetailsRequest = (
  url: string,
  payload: any,
  callback: unknown,
) => ({
  type: ADD_UPDATE_NAUTILUS_ITEMDETAILS_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateNautilusItemDetailsSuccess = (
  successMessage: string,
) => ({
  type: ADD_UPDATE_NAUTILUS_ITEMDETAILS_SUCCESS,
  payload: { successMessage },
});

export const addUpdateNautilusItemDetailsFailure = (error: string) => ({
  type: ADD_UPDATE_NAUTILUS_ITEMDETAILS_FAILURE,
  payload: error,
});
